import { useReducer } from 'react';

const toggleReducer = (state: boolean) => !state;

export const useToggle = ({ initialValue = false } = {}) => useReducer(toggleReducer, initialValue);
